<template>
  <Dialog :open="open" @close="$emit('close')">
    <template v-slot:title>
      <FlexRow justify="center" full-width>
        <Label text="テンプレートを削除します" size="h5" bold />
      </FlexRow>
    </template>
    <FlexColumn>
      <FormItem name="テンプレート名">
        <TextField
            :value="template.name"
            name="テンプレート名"
            readonly
        />
      </FormItem>
      <FormItem name="テンプレート内容">
        <TextArea
            :value="template.detail"
            name="テンプレート内容"
            readonly
        />
      </FormItem>
      <FlexRow justify="center">
        <Button outlined @click="$emit('close')">キャンセル</Button>
        <Button color="primary" @click="handleSubmit">削除</Button>
      </FlexRow>
    </FlexColumn>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import FlexRow from "../atoms/FlexRow";
import Label from "../atoms/Label";
import FlexColumn from "../atoms/FlexColumn";
import FormItem from "../molecules/FormItem";
import TextField from "../atoms/TextField";
import TextArea from "../atoms/TextArea";
import Button from "../atoms/Button";
import ApiMixin from "../../ApiMixin";
export default {
  name: "MessageTemplateDeleteDialog",
  mixins: [ApiMixin],
  components: {Button, TextArea, TextField, FormItem, FlexColumn, Label, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    template: {
      type: Object,
      default: () => ({})
    },
    companyId: {
      type: String
    }
  },
  methods: {
    async handleSubmit() {
      await this.deleteMessageTemplate(this.companyId, this.template.id)
      this.$emit("close")
    }
  },
}
</script>

<style scoped>

</style>